import React, { Component } from 'react'
import moment from 'moment'
import Select from 'react-select'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { waktuTempuh } from 'actions/dashboardAction'
import { portFetchAll } from 'actions/portAction'
import { AvForm } from 'availity-reactstrap-validation'
import { Row, Col, Card, CardHeader, CardBody, Button, FormGroup, Table, CardFooter, Pagination, PaginationItem, PaginationLink } from 'reactstrap'

let isDefaultKodeTrayek = false
let isDefaultPortOrigin = false
let isDefaultPortDestination = false

class WaktuTempuh extends Component {
  constructor(props) {
    super(props)
    this.state = {
      start: 0,
      curPage: 1,
      perPage: 10,
      kode_trayek: '',
      port_origin_id: '',
      port_origin_label: '',
      port_destination_id: '',
      port_destination_label: ''
    }

    this.selectKodeTrayek = this.selectKodeTrayek.bind(this)
    this.selectPortOrigin = this.selectPortOrigin.bind(this)
    this.selectPortDestination = this.selectPortDestination.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
  }

  componentDidMount() {
    let data = {
      length: 10
    }

    this.props.waktuTempuh(data)
    this.props.portFetchAll()
  }

  componentWillUnmount() {
    isDefaultKodeTrayek = false
    isDefaultPortOrigin = false
    isDefaultPortDestination = false
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.curPage !== this.state.curPage) {
      const data = {
        length: this.state.perPage,
        kode_trayek: this.state.kode_trayek,
        port_origin_id: this.state.port_origin_id,
        port_destination_id: this.state.port_destination_id
      }

      if (this.state.curPage === undefined) {
        data.start = this.state.start
      } else {
        let offset = (this.state.curPage * 10) - 10
        data.start = offset
      }

      this.props.waktuTempuh(data)
    }
  }

  selectKodeTrayek(opt) {
    if (opt) {
      this.setState({ kode_trayek: opt.value })
    } else {
      this.setState({ kode_trayek: '' })
    }
  }

  selectPortOrigin(opt) {
    if (opt) {
      this.setState({
        port_origin_id: opt.value,
        port_origin_label: opt.label
      })
    } else {
      this.setState({
        port_origin_id: '',
        port_origin_label: ''
      })
    }
  }

  selectPortDestination(opt) {
    if (opt) {
      this.setState({
        port_destination_id: opt.value,
        port_destination_label: opt.label
      })
    } else {
      this.setState({
        port_destination_id: '',
        port_destination_label: ''
      })
    }
  }

  handleClick(e) {
    this.setState({ curPage: e })
  }

  handleFilter(event, values) {
    if (this.state.kode_trayek) {
      values.kode_trayek = this.state.kode_trayek
      isDefaultKodeTrayek = true
    } else {
      delete values.kode_trayek
      isDefaultKodeTrayek = false
    }

    if (this.state.port_origin_id) {
      values.port_origin_id = this.state.port_origin_id
      isDefaultPortOrigin = true
    } else {
      delete values.port_origin_id
      isDefaultPortOrigin = false
    }

    if (this.state.port_destination_id) {
      values.port_destination_id = this.state.port_destination_id
      isDefaultPortDestination = true
    } else {
      delete values.port_destination_id
      isDefaultPortDestination = false
    }

    values.length = this.state.perPage

    this.props.waktuTempuh(values)
  }

  render() {
    if (this.props.waktuTempuhIsLoading) {
      return (
        <div>
          <p>Loading ..... </p>
        </div>
      )
    }

    if (this.props.waktuTempuhHasError) {
      return (
        <div>
          <p>Silahkan mencoba beberapa saat lagi, pastikan anda terkoneksi dengan internet</p>
        </div>
      )
    }

    return (
      <div>
        {this.renderData()}
      </div>
    )
  }

  renderData() {
    if (this.props.waktuTempuhIsSuccess) {
      let defaultValues = {
        kode_trayek: this.state.kode_trayek,
        port_origin_id: this.state.port_origin_id,
        port_origin_label: this.state.port_origin_label,
        port_destination_id: this.state.port_destination_id,
        port_destination_label: this.state.port_destination_label,
      }

      const prevPage = parseInt(this.props.waktuTempuhData.currentPage) - 1
      const nextPage = parseInt(this.props.waktuTempuhData.currentPage) + 1

      let curPage = this.props.waktuTempuhData.currentPage
      let minPage = Number(curPage) - 2
      let maxPage = Number(curPage) + 2

      const pages = []
      const totalPages = this.props.waktuTempuhData.pageTotal

      for (let index = 1; index <= totalPages; index++) {
        if (pages.indexOf(index) == -1) {
          pages.push(index)
        }
      }

      const { kode_trayek } = this.state.kode_trayek
      const { port_origin_id } = this.state.port_origin_id
      const { port_destination_id } = this.state.port_destination_id
      const defaultValueKodeTrayek = { label: defaultValues.kode_trayek, value: defaultValues.kode_trayek }
      const defaultValuePortOrigin = { label: defaultValues.port_origin_label, value: defaultValues.port_origin_id }
      const defaultValuePortDestination = { label: defaultValues.port_destination_label, value: defaultValues.port_destination_id }

      return (
        <div>
          <Card>
            <CardHeader>
              <h5>Waktu Tempuh</h5>
              <hr />
              <AvForm onValidSubmit={this.handleFilter} model={defaultValues}>
                <Row>
                  <Col md="3">
                    <FormGroup>
                      <Select name="kode_trayek"
                        value={kode_trayek}
                        isClearable
                        placeholder="Kode trayek..."
                        defaultValue={isDefaultKodeTrayek ? defaultValueKodeTrayek : false}
                        onChange={this.selectKodeTrayek}
                        options={this.props.waktuTempuhData.kode_trayek}
                        id="kode_trayek"
                        inputId="input_kode_trayek"
                        instanceId="instance_kode_trayek" />
                    </FormGroup>
                  </Col>
                  {this.props.portIsSuccess &&
                    <Col md="3">
                      <FormGroup>
                        <Select name="port_origin_id"
                          value={port_origin_id}
                          isClearable
                          placeholder="Pelabuhan asal..."
                          defaultValue={isDefaultPortOrigin ? defaultValuePortOrigin : false}
                          onChange={this.selectPortOrigin}
                          options={this.props.ports.data}
                          id="port_origin_id"
                          inputId="input_port_origin_id"
                          instanceId="instance_port_origin_id" />
                      </FormGroup>
                    </Col>
                  }
                  {this.props.portIsSuccess &&
                    <Col md="3">
                      <FormGroup>
                        <Select name="port_destinaton_id"
                          value={port_destination_id}
                          isClearable
                          placeholder="Pelabuhan tujuan..."
                          defaultValue={isDefaultPortDestination ? defaultValuePortDestination : false}
                          onChange={this.selectPortDestination}
                          options={this.props.ports.data}
                          id="port_destinaton_id"
                          inputId="input_port_destinaton_id"
                          instanceId="instance_port_destinaton_id" />
                      </FormGroup>
                    </Col>
                  }
                  <Col md="3" className="align-self-end">
                    <FormGroup className="form-actions">
                      <Button type="submit" size="md" color="primary" className=" btn-brand mr-1 mb-1"><i className="fa fa-search"></i><span>Proses </span></Button>
                    </FormGroup>
                  </Col>
                </Row>
              </AvForm>
            </CardHeader>
            <CardBody className="p-0">
              <Table responsive striped>
                <thead>
                  <tr>
                    <th className="text-center align-top">Kode Trayek</th>
                    <th className="text-center align-top">Voyage</th>
                    <th className="text-center align-top">Operator</th>
                    <th className="text-center align-top">Pelabuhan Asal</th>
                    <th className="text-center align-top">Pelabuhan Tujuan</th>
                    <th className="text-center align-top">Tanggal Berangkat</th>
                    <th className="text-center align-top">Tanggal Sampai</th>
                    <th className="text-center align-top">Waktu Tempuh</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.waktuTempuhData.data.map((item, key) => (
                    <tr key={key}>
                      <td className="text-center align-top">{item.kode_trayek}</td>
                      <td className="text-center align-top">{item.voyage && 'Voyage ' + item.voyage}</td>
                      <td className="text-center align-top">{item.operator_name}</td>
                      <td className="text-center align-top">{item.pelabuhan_asal}</td>
                      <td className="text-center align-top">{item.pelabuhan_tujuan}</td>
                      <td className="text-center align-top">
                        {item.atd ? (
                          <span>{moment(item.atd).format('DD MMMM YYYY')}</span>
                        ) : (
                            <span>{moment(item.tanggal_berangkat).format('DD MMMM YYYY')}</span>
                          )
                        }
                      </td>
                      <td className="text-center align-top">
                        {item.ata ? (
                          <span>{moment(item.ata).format('DD MMMM YYYY')}</span>
                        ) : (
                            <span>{moment(item.tanggal_tiba).format('DD MMMM YYYY')}</span>
                          )
                        }
                      </td>
                      <td className="text-center align-top">
                        {(item.waktu_tempuh && item.waktu_tempuh.days) ? (
                          <span>{item.waktu_tempuh.days + " Hari"}</span>
                        ) : (item.waktu_tempuh && item.waktu_tempuh.hours) ? (
                          <span>{item.waktu_tempuh.hours + " Jam"}</span>
                        ) : (<span></span>)
                        }
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </CardBody>
            <CardFooter>
              <Pagination>
                {this.props.waktuTempuhData.hasPrev ?
                  <PaginationItem>
                    <PaginationLink previous tag="button" onClick={(e) => this.handleClick(1)}>
                      First Page
                </PaginationLink>
                  </PaginationItem>
                  : null
                }

                {this.props.waktuTempuhData.hasPrev ?
                  <PaginationItem>
                    <PaginationLink previous tag="button" onClick={(e) => this.handleClick(prevPage)}>
                      Prev
                </PaginationLink>
                  </PaginationItem>
                  : null
                }

                {pages.map((item, index) => {
                  let actived = false
                  if (curPage === undefined) {
                    curPage = 1
                  }

                  if (item == curPage) {
                    actived = true
                  }

                  if (item >= minPage && item <= maxPage) {
                    return <PaginationItem active={actived} key={index}>
                      <PaginationLink tag="button" onClick={(e) => this.handleClick(item)}>
                        {item}
                      </PaginationLink>
                    </PaginationItem>
                  }
                })}

                {this.props.waktuTempuhData.hasNext ?
                  <PaginationItem>
                    <PaginationLink next tag="button" onClick={(e) => this.handleClick(nextPage)}>
                      Next
                </PaginationLink>
                  </PaginationItem>
                  : null
                }

                {this.props.waktuTempuhData.hasNext ?
                  <PaginationItem>
                    <PaginationLink next tag="button" onClick={(e) => this.handleClick(totalPages)}>
                      Last Page
                </PaginationLink>
                  </PaginationItem>
                  : null
                }
              </Pagination>

              {this.props.waktuTempuhData.pageTotal > 0 &&
                <p>Page: {this.props.waktuTempuhData.currentPage} of {this.props.waktuTempuhData.pageTotal}</p>
              }
            </CardFooter>
          </Card>
        </div>
      )
    }
  }
}

WaktuTempuh.propTypes = {
  waktuTempuhIsSuccess: PropTypes.bool.isRequired,
  waktuTempuhHasError: PropTypes.bool.isRequired,
  waktuTempuhIsLoading: PropTypes.bool.isRequired,

  portHasError: PropTypes.bool.isRequired,
  portIsLoading: PropTypes.bool.isRequired,
  portIsSuccess: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => {
  return {
    waktuTempuhData: state.dashboard.waktuTempuhData,
    waktuTempuhIsSuccess: state.dashboard.waktuTempuhSuccess,
    waktuTempuhHasError: state.dashboard.waktuTempuhError,
    waktuTempuhIsLoading: state.dashboard.waktuTempuhLoading,

    ports: state.ports.ports,
    portHasError: state.ports.portGetError,
    portIsSuccess: state.ports.portGetSuccess,
    portIsLoading: state.ports.portGetLoading
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    waktuTempuh: (data) => dispatch(waktuTempuh(data)),
    portFetchAll: () => dispatch(portFetchAll())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WaktuTempuh)